import { convertToLocalStyle, convertToConcatStyle, scrollbarStyle } from '@bingads-webui-campaign-react/common-styles';
import { pillControlStyle } from '@bingads-webui-react/scope-selector';

export const categoryContainerStyle = () => ({
  '& .category-container': {

    '& .grid-container': {
      padding: 1,
    },

    '& .panel-heading': {
      position: 'absolute',
      zIndex: 1,
      marginTop: 48,
      padding: '0 8px',
    },

    '& .autoSuggSearchBoxContainer': {
      height: 48,
      width: '100%',
      padding: 0,

      '& .searchbox-input': {
        height: 48,
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
      },

      '& .form-control-feedback': {
        position: 'absolute',
        left: 0,
        paddingTop: 4,
        pointerEvents: 'auto',
      },
    },

    '& .grid-table': {
      marginTop: 28,
      height: 400,
      overflowY: 'auto',

      '& .table': {
        tableLayout: 'fixed',
      },

      '& .col-sm-1': {
        display: 'none',
      },

      '& .table>thead>tr.table__row--header>th': {
        width: '50%',
        border: '0px !important',
        fontWeight: 600,

        '& .grid-asc, & .grid-des': {
          float: 'left',
        },

        '&.col-CategoryName': {
          '& .grid-asc, & .grid-des': {
            display: 'none',

            '&~.col-sm-8::before': {
              fontFamily: 'MsAds MDL2 Assets',
              position: 'relative',
              top: 3,
            },
          },

          '& .grid-asc~.col-sm-8::before': {
            content: '"\\EE68"',
          },

          '& .grid-des~.col-sm-8::before': {
            content: '"\\EE69"',
          },
        },


        '& .col-sm-1': {
          display: 'block',
          padding: 0,
          width: 'unset',
          marginLeft: 0,
          top: 0,

          '& .glyphicon-arrow-left': {
            display: 'none',
            padding: [2, 5, 0, 0],
          },
        },
      },

      '& .col-sm-8': {
        padding: 0,
      },

      '& tbody .col-CategoryName': {
        '& .col-sm-8': {
          width: '100%',
        },
      },

      '& .col-Coverage': {

        '& .col-sm-8': {
          '& span': {
            display: 'inline-block',
            textAlign: 'right',
          },
        },
        '& .col-sm-3': {
          width: 'auto',
          padding: 0,
          float: 'right',
        },
      },

      '& .table>tbody>tr>td': {
        height: 36,
        border: 0,
        padding: '0 8px',
        position: 'relative',
      },
    },

    '& .category-error': {
      display: 'none',
    },
  },
});

export const previewStyles = () => ({
  '& .summary': {
    borderTop: '1px solid #BBB',
    marginTop: 8,
    paddingTop: 8,
    position: 'relative',

    '& .preview': {
      padding: '0 8px',

      '& .operand': {
        marginRight: 2,
      },

      '& .popover-content': {
        padding: [20, 28, 10, 28],
      },
    },

    '& .col-sm-1': {
      position: 'absolute',
      right: 8,
    },
  },
});


export const dsaCampaignStyles = ({ palette = {} }) => ({
  /** step 1 */
  '& .dsa-targeting-source': {

    marginLeft: 20,
    ...convertToLocalStyle(scrollbarStyle({ palette })),

    '& .radio': {
      padding: [5, 8, 5, 28],
      position: 'relative',
      left: -28,
      display: 'table',

      '&:focus-within': {
        outline: `1px solid ${palette.neutralSecondary}`,
      },
    },

    '& .layout-columns-container': {
      maxWidth: 1020,
    },

    '& label': {
      display: 'block',
      padding: '5px 20px',
      paddingLeft: 20,
      fontWeight: 'normal',
    },

    '& .panel-form': {
      backgroundColor: 'white',
      border: '1px solid #BBB',
    },

    '& .col-sm-12': {
      padding: 0,
    },

    '& .panel-heading': {
      backgroundColor: '#E5E5E5',

      '& .panel-title': {
        margin: 0,
      },
    },

    '& .doubleListBox': {
      marginTop: 10,

      '& .layout-columns-element': {
        width: 350,
        padding: 0,

        '& .panel-form': {
          height: 482,

          '& .panel-heading': {
            height: 36,
            backgroundColor: '#ffffff',
            padding: 8,

            '& .panel-title': {
              color: '#323130',
              fontSize: 14,
              fontWeight: 600,
            },
          },

          '& .panel-body': {
            padding: 0,
            overflow: 'auto',
            paddingBottom: 2,

            '& .dlb-source-container': {
              height: 398,
            },

            '& .dlb-selected-container': {
              height: 446,
            },

            '& .dlb-emptyMessage': {
              padding: '0 8px',
            },

            '& .dlb-source-list, & .dlb-selected-list': {

              outline: 'none',

              '& .dlbItem': {
                height: 36,
                position: 'relative',
                padding: '0 8px',

                '& .dlbItem-actions, & .a11y-k-listview-button': {
                  position: 'absolute',
                  right: 8,
                  height: 36,
                  lineHeight: '36px',
                },

                '& .dlbItem-content': {
                  height: 36,
                  lineHeight: '36px',
                  paddingRight: '30px',

                  '& .itemTemplate-text': {
                    '& > span': {
                      display: 'block',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  },
                },

                '&:hover': {
                  backgroundColor: '#EDEBE9',
                },
              },
            },
          },
        },
      },

      '& .layout-columns-element:nth-child(1)': {
        position: 'absolute',
        height: 48,

        '& .dlb-filter-alignPlaceholder': {
          width: '100%',

          '& .searchbox': {
            padding: '0 1px',
            border: '1px solid #BBB',

            '& .searchbox-input': {
              height: 48,
              paddingLeft: 48,
            },

            '& .form-control-feedback': {
              position: 'absolute',
              left: 0,
              height: 48,
              lineHeight: '48px',
              pointerEvents: 'auto',

              '& .searchbox-searchbutton': {
                position: 'absolute',
              },
            },
          },
        },

        '& .panel-form': {
          height: 434,
        },
      },

      '& .layout-columns-element:nth-child(2)': {
        height: 'auto',
        marginTop: 48,

        '& .panel-form': {
          height: 434,
        },
      },

      '& .layout-columns-element:nth-child(3)': {
        height: 482,
        marginLeft: 8,
      },
    },
  },

  /** step 2 */
  '& .authoring-container': {
    width: 960,
    marginTop: 4,
    ...convertToLocalStyle(scrollbarStyle({ palette })),

    '& .pill-control': {
      ...pillControlStyle({ palette }),
      marginBottom: '17px',
    },

    '& .panel-heading': {
      padding: '5px 0',
      fontWeight: 600,

      '& .panel-title': {
        margin: 0,
        fontSize: 14,

        '& .h5': {
          fontSize: 14,
        },
      },
    },

    '& .panel-body': {
      padding: 0,

      '& .form-group': {
        width: '100% !important',
        float: 'none',
      },
    },

    '& .type-bold': {
      fontWeight: 600,
    },

    '& .target-type-radiogroup input[type="radio"]:focus': {
      outline: `1px solid ${palette.neutralSecondary} !important`,
    },

    '& .target-type-radiogroup span': {
      verticalAlign: 'top',
    },

    '& .form-group': {
      width: '100%',
      margin: 0,
      marginBottom: 10,
    },

    '& label': {
      display: 'block',
      padding: '5px 20px',
      fontWeight: 'normal',
    },

    '& .col-sm-12': {
      padding: 0,

      '& .type-bold': {
        fontSize: 14,
      },
    },


    '& .doubleListBox': {
      width: 'auto',
      marginBottom: '15px',

      '& >.col-sm-7': {
        width: 400,
        padding: 0,
      },

      '& .panel-heading': {
        color: '#323130',
        fontSize: 14,
        padding: '0 8px',
      },

      '& .panel-form': {
        border: `1px solid ${palette.neutralSecondary}`,
        height: 482,
      },

      '& .remaining-hint': {
        fontSize: 12,
        color: palette.neutralSecondary,
      },

      ...categoryContainerStyle(),

      '& .allwebpage-container': {
        '& .dlb-source-container': {
          marginTop: 15,
          padding: '0 8px',

          '& .select': {

            '& .col-sm-11': {
              padding: 0,
            },

            '& .col-sm-1': {
              position: 'absolute',
              right: 8,
            },
          },
        },
      },

      '& .exacturls-container': {
        '& .exact-urls-container': {
          '&  ::-webkit-scrollbar': {
            width: 8,
          },
          '& .form-control.exacturl-textarea': {
            width: 278,
            marginTop: 8,
            resize: 'None',
            minHeight: 360,
          },

          '& .web-condition': {
            float: 'left',
            marginLeft: 10,
            marginRight: 10,
            width: 90,
            '& .operand': {
              marginRight: 2,
              marginLeft: 8,
            },
          },
          '& .alert.alert-danger.url-equals-error': {
            width: 278,
            marginLeft: 107,
          },
        },

        '& div.addall': {
          marginTop: 16,
          paddingLeft: 107,
        },
      },

      '& .specificwebpage-container, .rules-container': {
        '& .panel-body': {

          overflowY: 'auto',
          overflowX: 'hidden',
          height: 450,

          '& div.addall': {
            marginTop: 16,
            marginLeft: 8,
          },

          '& .specific-target-container': {
            '& .specific-target-condition': {
              position: 'relative',
              margin: '8px 0 0 0 !important',

              '& .col-sm-4': {
                padding: 0,
                marginLeft: 8,
                width: 125,

                '& .form-control': {
                  width: 125,
                },
              },

              '& .col-sm-2': {
                padding: '0 8px',
                width: 72,
                minHeight: '1px',

                '& label': {
                  padding: 0,
                  height: 32,
                  lineHeight: '32px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
              },

              '& .col-sm-5': {
                padding: 0,
                width: 150,

                '& .form-control': {
                  width: 150,
                },

                '& .form-control-static': {
                  height: 'auto',
                  lineHeight: '32px',

                  '& span': {
                    verticalAlign: 'unset',
                  },
                },
              },

              '& .col-sm-1': {
                top: 6,
                width: 14,
                padding: 0,
                marginLeft: 8,
              },

              '& .col-sm-12': {
                '& label': {
                  padding: '0 0 8px 8px',
                  color: '#000',
                  fontWeight: '600',
                },
              },

              '& .category-container': {
                padding: 0,
                width: '100%',
                marginBottom: 8,

                '& .panel-form': {
                  border: 0,
                  borderTop: `1px solid ${palette.neutralSecondary}`,
                  borderBottom: `1px solid ${palette.neutralSecondary}`,
                  marginTop: 17,
                  height: 'auto',

                  '& .panel-body': {
                    height: 'auto',
                    overflowY: 'unset',
                  },

                  '& .grid-table': {
                    overflowY: 'unset',
                    height: 'auto',
                  },

                  '& .col-Coverage': {
                    '& .col-sm-7': {
                      width: 'auto',
                    },

                    '& .col-sm-5': {
                      width: 'auto',
                      position: 'absolute',
                      right: 8,
                    },
                  },
                },

                '& .category-error': {
                  display: 'none',
                },
              },
            },
          },

          '& .add-row': {
            padding: '0 8px',
          },

          ...previewStyles(),
        },
      },

      '& .autotarget-customlabel-container': {
        '& .col-sm-11': {
          paddingLeft: 8,
          paddingRight: 8,

          '& .custom-label-form-label, .custom-label-input': {
            width: '100%',
            padding: 0,

            '& label': {
              paddingLeft: 0,
            },

            '& input.form-control': {
              width: '100%',
            },
          },
        },

        '& .col-sm-1.form-control-static': {
          top: 35,
          right: 8,
        },
      },

      '& .selected-targets-container.col-sm-5': {
        width: 514,
        padding: 0,
        marginLeft: 8,

        '& .panel-form': {
          display: 'flex',
          flexDirection: 'column',

          '& .panel-heading': {
            padding: '0 8px',

            '& .panel-title': {

              '& .selected-header': {
                width: 'auto',
                padding: 0,

                '& .type-bold': {
                  float: 'left',
                  margin: 0,
                  padding: 0,
                  maxWidth: 340,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  lineHeight: '27px',
                },

                '& .helpbutton': {
                  width: '15px',
                  float: 'left',
                  padding: 0,
                },
              },

              '& .col-sm-4.h5': {
                width: 'auto',
                position: 'absolute',
                right: 8,
                padding: 0,
                margin: 0,
                textAlign: 'right',

                '& a': {
                  padding: 0,
                  fontWeight: 'normal',
                  maxWidth: 170,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  lineHeight: '27px',
                },
              },

              '& .selected-description': {
                '& .h5': {
                  fontWeight: 'normal',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                },
              },
            },
          },

          '& .panel-body': {
            flex: 1,
            overflow: 'auto',

            '& .remove-all': {
              right: 8,
              padding: 0,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'clip',
              marginBottom: 6,
              marginRight: 8,
              float: 'right',

              '& .remove': {
                display: 'none',
              },

              '& .col-sm-5': {
                width: 'auto',
                padding: 0,
              },
            },

            '& #BidValidationError': {
              padding: 0,
            },

            '& .inactive': {
              padding: '0 8px',
            },

            '& .dlb-selected-container': {
              height: '100%',
              overflow: 'auto',

              '& .dlb-selected-list': {
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
                alignItems: 'flex-end',

                '& .panel-body': {
                  width: '100%',
                },
              },

              '& ul[data-bind="foreach: items"]': {
                overflowY: 'auto',
                flex: 1,
                paddingLeft: 8,
                paddingRight: 8,
                clear: 'both',
                paddingBottom: 8,
                width: '100%',

                '& .dlbItem': {
                  height: 36,
                  padding: 2,
                  position: 'relative',

                  '& .arrow-button': {
                    position: 'absolute',
                    right: 0,
                    marginTop: 6,
                  },

                  '& .negative-targetName.targetName': {
                    width: 300,
                    '& .specificpage, .exacturls': {
                      '& .operand': {
                        maxWidth: 85,
                      },
                      '& .operator': {
                        maxWidth: 55,
                      },
                      '& .truncated': {
                        maxWidth: 150,
                      },
                    },
                  },

                  '& .targetName': {
                    width: 180,
                    height: 32,
                    lineHeight: '32px',
                    paddingLeft: 0,
                    paddingRight: 8,
                    '& .argument': {
                      verticalAlign: 'baseline',
                      marginLeft: 8,
                    },
                    '& div': {
                      display: 'inline-block',
                      verticalAlign: 'middle',
                    },

                    '& .specificpage, .exacturls': {
                      borderBottom: '1px dashed #0078D4',

                      '& .operand': {
                        marginRight: 2,
                        maxWidth: 55,
                        display: 'inline-block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      },

                      '& .operator': {
                        maxWidth: 50,
                        display: 'inline-block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      },

                      '& .preview-operand': {
                        '& .popover': {
                          marginTop: 0,
                          marginLeft: 11,
                          marginBottom: 20,
                          width: 173,
                          top: '0px !important',
                          left: '80px !important',

                          '& .arrow': {
                            left: '0px !important',
                            top: 12,
                          },

                          '& .popover-content': {
                            padding: '9px 14px',
                            fontSize: 14,

                            '& .conditions': {
                              '& .operand, .operator': {
                                fontWeight: 600,
                                maxWidth: 90,
                              },

                              '& .truncated': {
                                maxWidth: 150,
                                marginLeft: 0,
                                display: 'block',
                              },
                            },
                          },
                        },
                      },
                    },

                    '& .truncated': {
                      maxWidth: 60,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      marginLeft: 3,

                      '& a': {
                        color: '#323130',
                      },
                    },

                    '& .category': {
                      '& div:first-child span': {
                        maxWidth: 70,
                        display: 'inline-block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      },

                      '& .truncated': {
                        maxWidth: 100,
                      },
                    },

                    '& .allwebpage': {
                      '& span': {
                        maxWidth: 170,
                        display: 'inline-block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      },
                    },

                    '& span': {
                      verticalAlign: 'top',
                    },
                  },

                  '& .col-sm-4': {
                    width: 84,
                    height: 32,
                    padding: 0,

                    '& .form-control': {
                      width: 84,
                      margin: 0,
                    },

                  },

                },
              },
            },


          },
        },
      },

      '& .alert': {
        marginTop: 5,
        width: '100%',
      },

      '& span, & a': {
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
      },

      '& .edit-category-icon': {
        marginLeft: 5,
      },
    },

    '& .pager': {
      display: 'none',
    },
  },

  /** step 4 */
  '& .adgroupbid-grid': {
    marginLeft: 0,
    width: 460,
    marginBottom: 33,

    '& .text-left': {
      padding: '5px 10px',
    },

    '& .input-group-addon': {
      backgroundColor: '#FFFFFF',
      border: 0,
    },

    '& .grid-error-row': {
      '& .error-message': {
        color: '#A80000',
        fontSize: 12,
      },
    },

    '& .table>tbody>tr>td:first-child > span': {
      display: 'inline-block',
      overflow: 'hidden',
      maxWidth: '280px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
});

// this style is in the body scope, out of the feature scope, so use as the global pattern
export const globalDsaCampaignStyles = ({ palette = {} }) => ({
  '.k-list-container': {
    overflowY: 'auto',
    ...convertToConcatStyle(scrollbarStyle({ palette })),
  },

});
